import * as React from 'react';

import { useState } from 'react';

import { SelectableStateType } from '../types';
import { useSite, useTrackersSetup } from './backend';
import { useSearchFilter, useSortTrackers, useStateFilter } from '../util';
import { SiteHeader } from './site_header';
import { TrackerStateChoice } from './tracker_state_choice';
import { FilterInput } from './filter_input';
import { useUiState } from './ui_state';
import { TrackerSetupList } from './tracker_setup_list';

export interface SiteSetupViewProps {
  id: string;
}

export const SiteSetupView: React.FC<SiteSetupViewProps> = ({ id }) => {
  const siteQuery = useSite(id);
  const setupQuery = useTrackersSetup(id);

  const [filter, setFilter] = useState<string>('');
  const [state, setState] = useState<SelectableStateType>('all');

  const uiState = useUiState();

  const site = siteQuery.data;
  const entries = useSortTrackers(site?.trackers);
  const searchFiltered = useSearchFilter(entries, filter);
  const stateFiltered = useStateFilter(searchFiltered, state);

  const filteredTrackers = stateFiltered;

  return <div className="site">
    <div className="header">
      <SiteHeader site={site} />
    </div>
    <div className="content">
      <div className="list">
        <TrackerSetupList siteId={site?.id} trackers={filteredTrackers} setup={setupQuery.data} empty={entries?.length == 0} uiState={uiState} />
      </div>
    </div>
  </div>;
}

